import { IVcfUpdateStatusResponse } from './VcfCapabilityClient';


export function evaluate(resultToEvaluate: IVcfUpdateStatusResponse | undefined): boolean {
    const status = resultToEvaluate?.data?.status;
    return status === 'successful' || status === 'fail';
}